<template>
  <div class="position-relative">
    <section class="section section-shaped my-0">
      <div class="shape shape-default">
      </div>
      <div class="container shape-container d-flex">
        <div class="col px-0">
          <div class="row">
            <div class="col-lg-6">
              <h1 class="display-3 text-white">個人誌一覧
              </h1>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg">
      <div class="container pt-lg">
        <div class="row text-center justify-content-center">
          <div class="col-lg-10">
            <h2 class="display-3">新刊</h2>
            <p v-if="NewBooks.length" class="lead">現在の新刊は以下の通りです</p>
            <div v-else class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>
          </div>
        </div>
        <div v-for="(item,index) in NewBooks" :key="item.id">
          <div class="row row-grid align-items-center">
            <div class="col-md-8 order-md-1">
              <div class="pr-md-5">
                <h3>{{ item.Name }}</h3>
                <div v-if="item.SubTitle != null">
                  <h6>{{ item.SubTitle }}</h6>
                </div>
                <div v-if="item.DisplayCPName != null">
                  <h5>{{ item.DisplayCPName }}{{ item.Type }}</h5>
                </div>
                <div v-else>
                  <h5>{{ item.MainCharacter }}中心{{ item.Type }}</h5>
                </div>
                <div v-if="item.OtherCharacters != null">
                  <h6>　　その他主要人物：
                    <span v-for="(item2, index) in item.OtherCharacters" :key="item2.id">
                  {{ item2 }}
                  <span v-if="index != item.OtherCharacters.length - 1">,&nbsp;</span>
                </span>
                  </h6>
                </div>
                <h5>ジャンル：{{ item.Junle }}</h5>
                <h5>サイズ：{{ item.Size }} {{ item.Pages }}P</h5>
                <h5>発行日：{{ item.PublishDate }}（{{ item.EventName }}）</h5>
                <h5>価格：{{ item.Price }} 円（イベント頒布価格）</h5>
                <p class="lead">{{ item.Lead }}</p>
                <p v-html="item.Description"></p>
                <div class="btn-wrapper">
                  <div v-if="!item.OnlineStoreName || item.OnlineStoreName == 'BOOTH'">
                    <span v-if="item.OnSaleWithPaper == true && item.OnlineStore">
                      <a :href="item.OnlineStore" target="_blank">
                        <base-button class="mb-3 mb-sm-0"
                                     outline type="warning"
                                     icon="ni ni-cart">
                          BOOTHで購入
                        </base-button>
                      </a>
                    </span>
                    <span v-else-if="item.OnSaleWithPaper == true && !item.OnlineStore">
                      <base-button class="mb-3 mb-sm-0"
                                   outline type="warning"
                                   icon="fa-regular fa-clock" disabled>
                        BOOTH準備中
                      </base-button>
                    </span>
                    <span v-else-if="item.OnSaleWithDigital == true">
                      <a :href="item.OnlineStore" target="_blank">
                        <base-button class="mb-3 mb-sm-0"
                                     outline type="warning"
                                     icon="ni ni-tablet-button">
                          BOOTHで購入(電子版)
                        </base-button>
                      </a>
                    </span>
                    <span v-else>
                      <base-button class="mb-3 mb-sm-0"
                                   outline type="default" disabled
                                   icon="ni ni-fat-remove">
                        完売しました
                      </base-button>
                    </span>
                  </div>
                  <div v-if="item.OnlineStoreName == 'Melonbooks'">
                    <span v-if="item.OnSaleWithPaper == true && item.OnlineStore">
                      <a :href="item.OnlineStore" target="_blank">
                        <base-button class="mb-3 mb-sm-0"
                                     outline type="success"
                                     icon="ni ni-cart">
                          メロンブックスで購入
                        </base-button>
                      </a>
                    </span>
                    <span v-else-if="item.OnSaleWithPaper == true && !item.OnlineStore">
                      <base-button class="mb-3 mb-sm-0"
                                   outline type="success"
                                   icon="fa-regular fa-clock" disabled>
                        メロンブックス準備中
                      </base-button>
                    </span>
                    <span v-else>
                      <base-button class="mb-3 mb-sm-0"
                                   outline type="default" disabled
                                   icon="ni ni-fat-remove">
                        完売しました
                      </base-button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 order-md-2">
              <img :src=item.ImageUrl class="img-fluid shadow">
            </div>
          </div>
          <hr v-show="index !== NewBooks.length - 1">
        </div>
      </div>
    </section>
    <section class="section section-lg bg-secondary">
      <div class="container pt-lg">
        <div class="row text-center justify-content-center">
          <div class="col-lg-10">
            <h2 class="display-3">既刊一覧</h2>
          </div>
        </div>
        <BCard header="フィルタ" header-bg-variant="primary" header-text-variant="white" class="mb-5 mt-5">
          <div class="row mb-4">
            <div class="col-md-4">
              <label for="genre-select">ジャンル</label>
              <BFormSelect id="genre-select" v-model="genreFilter" :options="uniqueGenres" />
            </div>
            <div class="col-md-4">
              <label for="start-date">発行日（From）</label>
              <flat-pickr id="start-date" v-model="startDate" :config="flatpickrConfig" class="form-control" />
            </div>
            <div class="col-md-4">
              <label for="end-date">発行日（To）</label>
              <flat-pickr id="end-date" v-model="endDate" :config="flatpickrConfig" class="form-control" />
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-md-8">
              <label for="character-input">登場キャラクター</label>
              <BFormInput id="character-input" v-model="characterFilter" placeholder="キャラクター名を入力（カンマまたはスペース区切り）" />
            </div>
            <div class="col-md-4">
              <label>キャラクタ検索モード</label>
              <BFormRadioGroup v-model="searchMode" :options="searchModeOptions" />
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-md-12 text-center">
              <BButton @click="resetFilters" variant="primary">フィルタをリセット</BButton>
            </div>
          </div>
        </BCard>
        <div v-for="(item,index) in filteredBooks" :key="item.id">
          <div class="row row-grid align-items-center">
            <div class="col-md-8 order-md-1">
              <div class="pr-md-5">
                <h3>{{ item.Name }}</h3>
                <div v-if="item.SubTitle != null">
                  <h6>{{ item.SubTitle }}</h6>
                </div>
                <div v-if="item.DisplayCPName != null">
                  <h5>{{ item.DisplayCPName }}{{ item.Type }}</h5>
                </div>
                <div v-else>
                  <h5>{{ item.MainCharacter }}中心{{ item.Type }}</h5>
                </div>
                <h5>ジャンル：{{ item.Junle }}</h5>
                <h5>サイズ：{{ item.Size }} {{ item.Pages }}P</h5>
                <h5>発行日：{{ item.PublishDate }}（{{ item.EventName }}）</h5>
                <h5>価格：{{ item.Price }} 円（イベント頒布価格）</h5>
                <p class="lead">{{ item.Lead }}</p>
                <div class="btn-wrapper">
                  <router-link :to="item.BookDetailUrl">
                    <base-button :id="item.BookId" class="mb-3 mb-sm-0"
                                 outline type="primary"
                                 icon="ni ni-book-bookmark">
                      詳細情報
                    </base-button>
                  </router-link>
                  <span v-if="!item.OnlineStoreName || item.OnlineStoreName == 'BOOTH'">
                    <span v-if="item.OnSaleWithPaper == true && item.OnlineStore">
                      <a :href="item.OnlineStore" target="_blank">
                        <base-button class="mb-3 mb-sm-0"
                                     outline type="warning"
                                     icon="ni ni-cart">
                          BOOTHで購入
                        </base-button>
                      </a>
                    </span>
                    <span v-else-if="item.OnSaleWithPaper == true && !item.OnlineStore">
                      <base-button class="mb-3 mb-sm-0"
                                   outline type="warning"
                                   icon="fa-regular fa-clock" disabled>
                        BOOTH準備中
                      </base-button>
                    </span>
                    <span v-else-if="item.OnSaleWithDigital == true">
                      <a :href="item.OnlineStore" target="_blank">
                        <base-button class="mb-3 mb-sm-0"
                                     outline type="warning"
                                     icon="ni ni-tablet-button">
                          BOOTHで購入(電子版)
                        </base-button>
                      </a>
                    </span>
                    <span v-else>
                      <base-button class="mb-3 mb-sm-0"
                                   outline type="default" disabled
                                   icon="ni ni-fat-remove">
                        完売しました
                      </base-button>
                    </span>
                  </span>
                  <span v-if="item.OnlineStoreName == 'Melonbooks'">
                    <span v-if="item.OnSaleWithPaper == true && item.OnlineStore">
                      <a :href="item.OnlineStore" target="_blank">
                        <base-button class="mb-3 mb-sm-0"
                                     outline type="success"
                                     icon="ni ni-cart">
                          メロンブックスで購入
                        </base-button>
                      </a>
                    </span>
                    <span v-else-if="item.OnSaleWithPaper == true && !item.OnlineStore">
                      <base-button class="mb-3 mb-sm-0"
                                   outline type="success"
                                   icon="fa-regular fa-clock" disabled>
                        メロンブックス準備中
                      </base-button>
                    </span>
                    <span v-else>
                      <base-button class="mb-3 mb-sm-0"
                                   outline type="default" disabled
                                   icon="ni ni-fat-remove">
                        完売しました
                      </base-button>
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-md-4 order-md-2">
              <div v-if="item.Image !== null">
                <img :src=item.ImageUrl class="img-fluid shadow">
              </div>
            </div>
          </div>
          <hr v-show="index !== filteredBooks.length - 1">
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { useHead } from '@vueuse/head'
import 'moment/locale/ja'
import moment from "moment";
import { BFormSelect, BFormInput, BFormRadioGroup, BButton, BCard } from 'bootstrap-vue-next';
import FlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {Japanese} from "flatpickr/dist/l10n/ja";

export default {
  setup() {
    useHead({
      meta: [
        { property: 'og:title', content: '雛菊書房 - 個人誌一覧' },
        { property: 'og:type', content: 'website' },
        { property: 'og:description', content: '小説二次創作中心同人小説サークル「雛菊書房」が発行している個人誌一覧' },
        { property: 'og:image', content: location.origin + '/img/brand/default.png' },
        { property: 'twitter:card', content: 'summary' },
      ]
    })
  },
  name: "books",
  components: {
    moment,
    BFormSelect,
    BFormInput,
    BFormRadioGroup,
    BButton,
    BCard,
    FlatPickr
  },
  data() {
    return{
      Books: [],
      NewBooks: [],
      Events: [],
      genreFilter: null,
      startDate: null,
      endDate: null,
      characterFilter: '',
      searchMode: 'AND',
      searchModeOptions: [
        { text: 'AND', value: 'AND' },
        { text: 'OR', value: 'OR' },
      ],
      flatpickrConfig: {
        locale: Japanese,
        dateFormat: 'Y/m/d',
        altFormat: 'Y/m/d',
        altInput: true,
        allowInput: true,
      },
    };
  },
  created() {
    moment.locale('ja')
    this.getEvents().then(() => {
      this.getBooks()
    })
  },
  computed: {
    uniqueGenres() {
      const genres = [...new Set(this.Books.map(book => book.Junle))];
      return [{ value: null, text: '全て' }, ...genres.map(genre => ({ value: genre, text: genre }))];
    },
    filteredBooks() {
      return this.Books.filter(book => {
        const matchesGenre = this.genreFilter ? book.Junle === this.genreFilter : true;
        const matchesStartDate = this.startDate ? moment(book.PublishDate, 'YYYY/MM/DD').isSameOrAfter(moment(this.startDate, 'YYYY/M/D')) : true;
        const matchesEndDate = this.endDate ? moment(book.PublishDate, 'YYYY/MM/DD').isSameOrBefore(moment(this.endDate, 'YYYY/M/D')) : true;
        const characters = [book.MainCharacter, book.PartnerCharacter, ...(book.OtherCharacters || [])].filter(Boolean);
        let matchesCharacter = true;
        if (this.characterFilter) {
          const searchChars = this.characterFilter.split(/[, ]+/).filter(Boolean);
          if (this.searchMode === 'OR') {
            matchesCharacter = searchChars.some(searchChar => characters.some(char => char.includes(searchChar)));
          } else {
            matchesCharacter = searchChars.every(searchChar => characters.some(char => char.includes(searchChar)));
          }
        }
        return matchesGenre && matchesStartDate && matchesEndDate && matchesCharacter;
      });
    },
  },
  methods: {
    getBooks() {
      this.axios.get('/strapi/api/book-informations?populate=%2A&filters[IsAnthology][$eq]=false&pagination[pageSize]=100')
        .then(response =>{
          this.Books = response.data.data
          this.Books.forEach(function (value, index, array){
            if(value['EventId'] !== null){
              if(this.Events.find(el => Number(el.EventId) == Number(value['EventId'])) != null) {
                array[index]['EventName'] = this.Events.find(el => el.EventId == value['EventId']).Name
                array[index]['EventInfo'] = this.Events.find(el => el.EventId == value['EventId'])
              }
            }
            switch (value['Size']){
              case 'Duodecimo':
                array[index]['Size'] = "四六判";
                break;
              case 'Paperback':
                array[index]['Size'] = "文庫";
                break;
              case 'Others':
                array[index]['Size'] = "その他";
                break;
              default:
                break;
            }
            switch (value['Type']){
              case 'Normal':
                array[index]['Type'] = "小説本";
                break;
              case 'Short':
                array[index]['Type'] = "短編小説本";
                break;
              case 'ShortStories':
                array[index]['Type'] = "短編集";
                break;
              case 'Series':
                array[index]['Type'] = "小説本(シリーズ)";
                break;
              case 'LongStory':
                array[index]['Type'] = "中長編小説本";
                break;
              case 'StoryAnthology':
                array[index]['Type'] = "小説合同誌・アンソロジー";
                break;
              case 'StoryComicsAnthology':
                array[index]['Type'] = "小説漫画合同誌・アンソロジー";
                break;
              case 'AllTypeAnthology':
                array[index]['Type'] = "合同誌・アンソロジー";
                break;
              case 'Others':
                array[index]['Type'] = value['OtherType'];
                break;
              default:
                break;
            }
            array[index]['PublishDate'] = moment(value['PublishDate']).format('YYYY/MM/DD')
            if (array[index]['Description'] !== null){
              array[index]['Description'] = value['Description'].replace(/\r?\n/g, '<br >');
            }
            array[index]['BookDetailUrl'] = "/bookDetail/" + value['BookId']
            if(array[index]['Image']){
              array[index]['ImageUrl'] = '/strapi' + value['Image']['formats']['small']['url']
            }
          }, this)
          let MostNewPublishDate = this.Books.sort(function (a, b){
            return (a.PublishDate > b.PublishDate) ? -1 : 1;
          })[0].PublishDate
          this.NewBooks = this.Books.filter(el => el.PublishDate == MostNewPublishDate)
        }).catch(error =>{
          console.log(error)
      })
    },
    getEvents() {
      return this.axios.get('/strapi/api/event-informations?pagination[pageSize]=100')
          .then(response =>{
            this.Events = response.data.data
          }).catch(error =>{
        console.log(error)
      })
    },
    resetFilters() {
      this.genreFilter = null;
      this.startDate = null;
      this.endDate = null;
      this.characterFilter = '';
      this.searchMode = 'AND';
    },
  }
};
</script>
<style>
</style>
